import { InputHTMLAttributes, useState } from 'react'
import { cn } from '@global/utils/tailwind'
import SearchSVG from 'images/search.svg'
import { t } from '@lingui/core/macro'

interface InputSearchProps extends InputHTMLAttributes<HTMLInputElement> {
  onChange: (value) => void
  value: string
}

export const SearchField = ({ value, onChange, ...props }: InputSearchProps) => {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className="relative">
      <input
        {...props}
        type="text"
        className={cn(
          'w-full h-[36px] border border-gray-300 rounded-md',
          'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent',
          'px-3.5 py-2.5 text-sm text-black',
          isFocused ? 'pl-4' : 'pl-10',
        )}
        onFocus={() => {
          setIsFocused(true)
        }}
        onBlur={() => {
          setIsFocused(false)
        }}
        value={value}
        onChange={onChange}
        placeholder={t`Search`}
        data-cy="search-input"
      />
      {!isFocused && (
        <div
          className="
            absolute inset-y-0 left-0
            flex items-center pl-3
            pointer-events-none
          "
        >
          <SearchSVG />
        </div>
      )}
    </div>
  )
}
